/* eslint-disable */
import UseAnimations from "react-useanimations";
import loading from "react-useanimations/lib/loading";

export default function SecondaryButton({
  disabled = false,
  isLoading = false,
  onClick = () => null,
  children = <span>Submit</span>,
}) {
  const css = "disp-flex center radius regular-txt body-txt secondary-btn";

  if (disabled) {
    return (
      <button
        className={css}
        disabled={disabled}
        type="button"
        onClick={onClick}
      >
        {isLoading ? (
          <UseAnimations animation={loading} size={20} strokeColor="#E95A13" />
        ) : (
          children
        )}
      </button>
    );
  }

  return (
    <button className={css} disabled={disabled} type="button" onClick={onClick}>
      {children}
    </button>
  );
}
